import { GetSectionResult } from "../../../assessment-sections";

export class GetAdminSectionResult extends GetSectionResult {};